import { render, staticRenderFns } from "./IframeResize-datawrapper.vue?vue&type=template&id=766e4ed0&"
import script from "./IframeResize-datawrapper.vue?vue&type=script&lang=js&"
export * from "./IframeResize-datawrapper.vue?vue&type=script&lang=js&"
import style0 from "./IframeResize-datawrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports